import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateClientOrganization(
    $id: String!
    $data: updateClientOrganizationInput!
  ) {
    updateClientOrganization(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateClientOrganizationRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateClientOrganizationInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/update_client_organization',
  async (
  params: {id: String;data: TYPES.UpdateClientOrganizationInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateClientOrganization;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateClientOrganizationSlice = createSlice({
  name: 'update_client_organization',
  initialState: initialState,
  reducers: {
    updateClientOrganizationClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateClientOrganizationRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      updateClientOrganizationRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(updateClientOrganizationRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateClientOrganizationClear } =
updateClientOrganizationSlice.actions;

export const updateClientOrganization = createSelector(
  (state: RootState) => state.organization.updateClientOrganization.result,
  (state: RootState) => state.organization.updateClientOrganization.error,
  (state: RootState) => state.organization.updateClientOrganization.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateClientOrganizationSlice.reducer;